import { useEffect, useRef } from "react";
import { logPrintLanguage } from "../services/dashboardServices";
import { codeToLanguage } from "../utils/googleTranslate";

const getCookie = (name) => {
  const match = document.cookie.match(
    new RegExp("(?:^|; )" + name + "=([^;]*)")
  );
  return match ? decodeURIComponent(match[1]) : "";
};

const useCookieLanguageLogger = (publicId) => {
  const last = useRef(getCookie("googtrans"));

  useEffect(() => {
    const interval = setInterval(() => {
      const current = getCookie("googtrans");
      if (current && current !== last.current) {
        last.current = current;
        const [, , code] = current.split("/");
        const languageChoosen = codeToLanguage[code] || code;
        logPrintLanguage(publicId, languageChoosen || "").catch(console.error);
      }
    }, 500);

    return () => clearInterval(interval);
  }, [publicId]);
};

export { useCookieLanguageLogger };
